<template>
  <span v-if="recommendationAvailable">
    <sweet-button @click="applyRecommendation()" variant="primary" icon="mdi mdi-check" size="sm" buttonClass="mt-2 ml-2 float-right">
      {{ $t("common.apply-recommendation") }}
    </sweet-button>
  </span>
</template>

<script>
export default {
  computed: {
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },

    recommendation() {
      const recommendation = this.$store.getters["datasourcePhysicalStorage/recommendation"];
      if (recommendation == "OK") return null;
      return recommendation;
    },
    recommendationAvailable() {
      return !!this.recommendation;
    },
  },

  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler() {
        this.fethcRecommendation();
      },
    },
  },
  methods: {
    async fethcRecommendation() {
      const isLoading = this.$store.getters["datasourcePhysicalStorage/isLoading"];
      if (isLoading) {
        return;
      }
      await this.$store.dispatch("datasourcePhysicalStorage/recommendStoragePeriod");
    },
    applyRecommendation() {
      this.$emit("onApply", {
        period: this.recommendation.period,
        since: this.recommendation.since,
        legalBasis: this.recommendation.legalBasis,
      });
    },
  },
};
</script>

<style></style>
